module.exports = __webpack_public_path__ + "assets/img/10_vipcom_100x100.c24f364c.png";